import React, { FC, RefObject } from 'react'

import AccountField from '../components/AccountField'
import { accountsNames } from '../constants'

const DebitAccountField: FC<{
  FormName: string
  debitAccountSearchButtonRef?: RefObject<any>
  searchAccountsFetcherName: string
  disabled: boolean
  checkClient?: any
  isRequired?: boolean
}> = ({ FormName, debitAccountSearchButtonRef, searchAccountsFetcherName, disabled, checkClient, isRequired }) => (
  <AccountField
    name="DebitAccNo"
    disabled={disabled}
    //@ts-ignore
    checkClient={checkClient}
    FormName={FormName}
    fetcherName={searchAccountsFetcherName}
    accountCredentials={accountsNames.debit}
    searchButtonRef={debitAccountSearchButtonRef}
    isRequired={isRequired}
  />
)

export default DebitAccountField
